export default "__VITE_ASSET__BdxEbFQl__"